{
  "WALLBOARD": {
    "LOADING": "Ładowanie kolejek telefonicznych...",
    "NO_QUEUES": "Nie znaleziono kolejek telefonicznych.",
    "AGENTS": "Agenci",
    "NO_AGENTS": "Brak agentów online w tej kolejce.",
    "NO_AGENTS_ONLINE": "Brak agentów online.",
    "WAITING_CALLERS": "Oczekujący dzwoniący",
    "NO_CALLERS": "Brak oczekujących dzwoniących.",
    "UNKNOWN_CALLER": "Nieznany dzwoniący",
    "POSITION": "Pozycja",
    "STATUS": "Status",
    "TIME": "Czas",
    "AGENT": "Agent",
    "EXTENSION": "Numer wewnętrzny",
    "AVAILABLE": "Dostępny",
    "READY": "Gotowi agenci",
    "ON_CALL": "Agenci w trakcie połączenia",
    "QUEUE_CALL": "Połączenie z kolejki",
    "OTHER_CALL": "Inne połączenie",
    "PAUSED": "Agenci na przerwie",
    "WAITING": "Oczekujące połączenia",
    "MISSED_CALLS": "Nieodebrane połączenia",
    "HANDLED_CALLS": "Obsłużone połączenia przychodzące",
    "OUTBOUND_CALLS": "Obsłużone połączenia wychodzące",
    "AVAILABILITY": "Dostępność",
    "AVAILABILITY_TOOLTIP": "Procent połączeń przychodzących odebranych przez agentów (połączenia, które zostały odebrane)",
    "TOTAL": "łącznie",
    "AGENTS_COUNT": "({onCall} w połączeniu / {total} łącznie)",
    "NO_AVAILABLE": "(nikt nie jest online)",
    "WAITING_CALLERS_COUNT": "{count} oczekujących",
    "CALLER": "Dzwoniący",
    "NUMBER": "Numer",
    "WAIT_TIME": "Czas oczekiwania",
    "QUEUES": "Kolejki",
    "ACTION": "Akcja",
    "PICKUP_CALL": "Odbierz",
    "PICKING_UP": "Odbieranie...",
    "PICKUP_SUCCESS": "Pomyślnie zażądano odebrania połączenia.",
    "PICKUP_ERROR": "Nie udało się odebrać połączenia. Spróbuj ponownie.",
    "PICKUP_DISABLED_TOOLTIP": "Nie możesz odebrać połączenia podczas trwającej rozmowy lub będąc offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Brak dostępu"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Brak dostępu"
    }
  }
}
